import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Icon/IconUsage.mdx";

import Examples from "../../Docs/Components/Icon/IconExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Icon"
            description="Icons can represent concepts and make it easier to visually understand content and actions."
            apiSources={["azure-devops-ui/Components/Icon/Icon.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"Planned (Q3)"}}
            usage={Usage}
        />
    );
}
}
        
export default Page;